import { Routes } from '@angular/router';
import { sessionGuard } from '../../guards/session.guard';

export const authRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    data: { key: 'create-company' },
    loadComponent: () => import('./create-company/create-company.page').then((m) => m.CreateCompanyPage),
    path: 'create-company',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'otp-sent' },
    loadComponent: () => import('./otp-sent/otp-sent.page').then((m) => m.OtpSentPage),
    path: 'otp-sent',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'sign-in' },
    loadComponent: () => import('./sign-in/sign-in.page').then((m) => m.SignInPage),
    path: 'sign-in',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'verify' },
    loadComponent: () => import('./verify/verify.page').then((m) => m.VerifyPage),
    path: 'verify',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'verify-invitation' },
    loadComponent: () => import('./verify-invitation/verify-invitation.page').then((m) => m.VerifyInvitationPage),
    path: 'verify-invitation/:token',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'onboarding' },
    loadComponent: () => import('./onboarding/onboarding.page').then((m) => m.OnboardingPage),
    path: 'onboarding',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'company-subscription' },
    loadComponent: () => import('./company-subscription/company-subscription.page').then((m) => m.CompanySubscriptionPage),
    path: 'company-subscription',
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'sign-in',
  },
];
